import { useEffect, useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';

import { Wrapper, Input, SearchIcon, DropdownWrapper, NoRecommendations, ItemWrapper, ValueContainer } from './styles';

// When passing recommendations to this component, wrap it in 'useMemo'.
const RecommendationInput = ({
  recommendations = [],
  value = '',
  onChange,
  placeholder = '',
  isDisabled = false,
  wrapperStyle = {},
}) => {
  const wrapperRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [filteredRecommendations, setFilteredRecommendations] = useState([]);

  const filterValues = (val = '') => {
    const search = val.trim().toLowerCase();
    if (search === '') {
      setFilteredRecommendations(recommendations);
    } else {
      const filtered = recommendations.filter((v) => v.toLowerCase().includes(search));
      setFilteredRecommendations(filtered);
    }
  };

  const onInputChange = (e) => {
    onChange && onChange(e.target.value);
    filterValues(e.target.value);
  };

  const onRecommendationClick = (val) => {
    onChange && onChange(val, true);
    closeDropdown();
    filterValues(val);
  };

  const onInputFocus = () => {
    filterValues(value);
    setIsOpen(true);
  };

  const closeDropdown = () => setIsOpen(false);

  useEffect(() => {
    setFilteredRecommendations(recommendations);
  }, [recommendations]);

  useClickOutside(wrapperRef, closeDropdown);
  return (
    <Wrapper
      ref={wrapperRef}
      style={wrapperStyle}>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={onInputChange}
        onFocus={onInputFocus}
        disabled={isDisabled}
      />
      <SearchIcon />
      {isOpen && (
        <DropdownWrapper>
          {filteredRecommendations.length === 0 ? (
            <NoRecommendations>No Recommendations</NoRecommendations>
          ) : (
            filteredRecommendations.map((recommendation, ind) => (
              <ItemWrapper
                key={ind}
                onClick={() => onRecommendationClick(recommendation)}>
                <ValueContainer>{recommendation}</ValueContainer>
              </ItemWrapper>
            ))
          )}
        </DropdownWrapper>
      )}
    </Wrapper>
  );
};

export default RecommendationInput;
